import packageJson from '../../../../package.json';
import { environment } from 'src/environments/environment';
export const globalConfig = {
    apiUrl: environment.API_URL,
    azure_key: null,
    version: packageJson.version,
    socketUrl: environment.SOCKET_URL,
    // Datos de la sesion
    tokenApi: 'access_token',
    permisosUsuario: 'permisosUsuario',
    recapchaSiteKey: environment.siteKey,

  };
